import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Misafir "genel QR"yı okur → masa seç ekranı → sonra /guest-order/{id}
export function GuestMenuLanding() {
  const [tables, setTables] = useState([]);
  const [loading, setLoading] = useState(true);
  const nav = useNavigate();

  useEffect(() => {
    fetch(`${API_URL}/api/snack-bar/public/tables`)
      .then(r => r.json())
      .then(j => setTables(j.items || []))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-emerald-950 to-slate-900 p-4" data-testid="guest-landing">
      <div className="max-w-md mx-auto pt-8">
        {/* Brand */}
        <div className="text-center mb-8 text-white">
          <div className="w-20 h-20 mx-auto rounded-3xl bg-gradient-to-br from-emerald-500 to-teal-600 flex items-center justify-center shadow-2xl mb-3">
            <span className="text-4xl">🍽</span>
          </div>
          <h1 className="text-3xl font-black tracking-tight">Grand Kaptan</h1>
          <p className="text-emerald-300 text-sm uppercase tracking-[0.3em] mt-1">Snack Bar</p>
        </div>

        {/* Hoş geldin */}
        <div className="bg-white/10 backdrop-blur-xl rounded-2xl p-6 mb-4 text-white border border-white/10">
          <div className="text-2xl font-bold mb-1">Hoş geldiniz 👋</div>
          <div className="text-emerald-200 text-sm">Sipariş için önce masanızı seçin.</div>
        </div>

        {/* Masa grid */}
        <div className="bg-white rounded-2xl p-4 shadow-2xl">
          <div className="text-xs uppercase tracking-widest text-slate-500 mb-3">Masanızı Seçin</div>
          {loading ? (
            <div className="text-center py-8 text-slate-400">Yükleniyor…</div>
          ) : tables.length === 0 ? (
            <div className="text-center py-8 text-slate-400">Masa tanımlı değil.</div>
          ) : (
            <div className="grid grid-cols-4 gap-2">
              {tables.map(t => (
                <button
                  key={t.id}
                  onClick={() => nav(`/guest-order/${t.id}`)}
                  data-testid={`landing-table-${t.name}`}
                  className="aspect-square rounded-xl border-2 border-slate-200 hover:border-emerald-500 hover:bg-emerald-50 font-bold text-slate-800 transition-all active:scale-95"
                >
                  <div className="text-lg">{t.name}</div>
                  {t.zone && <div className="text-[10px] font-normal text-slate-500">{t.zone}</div>}
                </button>
              ))}
            </div>
          )}
        </div>

        {/* Alt */}
        <div className="text-center text-emerald-300/60 text-xs mt-6">
          Grand Kaptan Hotel — Afiyet olsun
        </div>
      </div>
    </div>
  );
}
